import { Component, ElementRef, HostListener, OnInit } from '@angular/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'ac-sticky-footer',
	templateUrl: './sticky-footer.component.html',
	styleUrls: ['./sticky-footer.component.scss']
})
export class StickyFooterComponent implements OnInit {
	constructor(private element: ElementRef) { }

	public ngOnInit(): void {
		this.onDocumentScroll();
	}

	@HostListener('document:scroll', ['$event'])
	public onDocumentScroll(): void {
		const elements = this.element.nativeElement.querySelector('.ac-sticky-footer');
		const parentElements = elements.parentElement.parentElement.parentElement;
		const scrollPositionAtTheEndOfParentComponent = parentElements.offsetTop + parentElements.clientHeight;
		const bottomPositionOfWhatIsVisibleOnScreen = document.documentElement.scrollTop + window.innerHeight;
		const spaceLeft = scrollPositionAtTheEndOfParentComponent - bottomPositionOfWhatIsVisibleOnScreen + elements.clientHeight;
		const positionThatComponentIsVisible = parentElements.offsetTop + elements.clientHeight;

		if (spaceLeft > 0 && positionThatComponentIsVisible < bottomPositionOfWhatIsVisibleOnScreen) {
			elements.style.position = 'fixed';
		} else {
			elements.style.position = 'absolute';
		}
	}
}
